import { defineAsyncComponent } from 'vue';

const globalComponents = {
  accordion: defineAsyncComponent(() => import('@/components/Accordion.vue')),
  'activity-card': defineAsyncComponent(() => import('@/components/content/ActivityCard.vue')),
  'add-user-form': defineAsyncComponent(() => import('@/components/admin/users/AddUserForm.vue')),
  'ageoptions-registration-invite-part-3': defineAsyncComponent(() =>
    import('@/components/registration-form/instances/AgeoptionsRegistrationInvitePart3.vue')
  ),
  'alert-message': defineAsyncComponent(() => import('@/components/AlertMessage.vue')),
  'announcement-banner': defineAsyncComponent(() => import('@/components/AnnouncementBanner.vue')),
  'anonymous-groups-popup': defineAsyncComponent(() =>
    import('@/components/events/AnonymousGroupsPopup.vue')
  ),
  'learning-page-recommendations': defineAsyncComponent(() =>
    import('@/components/content/LearningPageRecommendations.vue')
  ),
  'article-field': defineAsyncComponent(() => import('@/components/article/ArticleField.vue')),
  'article-fields': defineAsyncComponent(() => import('@/components/article/ArticleFields.vue')),
  'audio-field': defineAsyncComponent(() => import('@/components/audio/AudioField.vue')),
  'audio-fields': defineAsyncComponent(() => import('@/components/audio/AudioFields.vue')),
  'audio-player': defineAsyncComponent(() => import('@/components/audio/AudioPlayer.vue')),
  'backend-validation-alert': defineAsyncComponent(() =>
    import('@/components/BackendValidationAlert.vue')
  ),
  'badge-course-mapping': defineAsyncComponent(() => import('@/components/BadgeCourseMapping.vue')),
  'badge-list': defineAsyncComponent(() => import('@/components/badges/BadgeList.vue')),
  'badge-order': defineAsyncComponent(() => import('@/components/badges/BadgeOrder.vue')),
  'callout-illustration': defineAsyncComponent(() =>
    import('@/components/illustration/CalloutIllustration.vue')
  ),
  'care-details': defineAsyncComponent(() => import('@/components/profile/CareDetails.vue')),
  'caregiver-view-banner': defineAsyncComponent(() =>
    import('@/components/CaregiverViewBanner.vue')
  ),
  'certification-enable-button': defineAsyncComponent(() =>
    import('@/components/CertificationEnableButton.vue')
  ),
  'certification-faq': defineAsyncComponent(() =>
    import('@/components/certification/CertificationFaq.vue')
  ),
  'certification-group-button': defineAsyncComponent(() =>
    import('@/components/CertificationGroupButton.vue')
  ),
  'certification-lessons-counter': defineAsyncComponent(() =>
    import('@/components/certification/CertificationLessonsCounter.vue')
  ),
  'certification-list': defineAsyncComponent(() =>
    import('@/components/certification/CertificationList.vue')
  ),
  'certification-module-list': defineAsyncComponent(() =>
    import('@/components/certification/CertificationModuleList.vue')
  ),
  'certification-modules': defineAsyncComponent(() =>
    import('@/components/certification/CertificationModules.vue')
  ),
  'certification-navigation': defineAsyncComponent(() =>
    import('@/components/certification/CertificationNavigation.vue')
  ),
  'certification-outline': defineAsyncComponent(() =>
    import('@/components/certification/CertificationOutline.vue')
  ),
  'certification-quiz': defineAsyncComponent(() =>
    import('@/components/quiz/CertificationQuiz.vue')
  ),
  'change-password': defineAsyncComponent(() => import('@/components/profile/ChangePassword.vue')),
  'char-counter': defineAsyncComponent(() => import('@/components/admin/CharCounter.vue')),
  'check-in-frequency-setting': defineAsyncComponent(() =>
    import('@/components/check-in/CheckInFrequencySetting.vue')
  ),
  'check-in-journey-chart': defineAsyncComponent(() =>
    import('@/components/check-in/CheckInJourneyChart.vue')
  ),
  'check-in-record': defineAsyncComponent(() => import('@/components/check-in/CheckInRecord.vue')),
  'check-in-summary': defineAsyncComponent(() =>
    import('@/components/check-in/CheckInSummary.vue')
  ),
  'check-in-survey': defineAsyncComponent(() => import('@/components/check-in/CheckInSurvey.vue')),
  'forum-page': defineAsyncComponent(() => import('@/pages/ForumPage.vue')),
  'connect-learn-list': defineAsyncComponent(() => import('@/components/ConnectLearnList.vue')),
  'contact-list-tooltip': defineAsyncComponent(() => import('@/components/ContactListTooltip.vue')),
  'content-feedback': defineAsyncComponent(() =>
    import('@/components/content/ContentFeedback.vue')
  ),
  'content-slider': defineAsyncComponent(() => import('@/components/content/ContentSlider.vue')),
  'country-state-select': defineAsyncComponent(() => import('@/components/CountryStateSelect.vue')),
  'county-selection': defineAsyncComponent(() => import('@/components/CountySelection.vue')),
  'course-card': defineAsyncComponent(() => import('@/components/badges/CourseCard.vue')),
  'course-outline': defineAsyncComponent(() => import('@/components/badges/CourseOutline.vue')),
  'v-sweet-alert': defineAsyncComponent(() => import('@/components/generics/VSweetAlert.vue')),
  'create-question': defineAsyncComponent(() => import('@/components/quiz/CreateQuestion.vue')),
  'cta-banner': defineAsyncComponent(() => import('@/components/banners/CtaBanner.vue')),
  'date-picker': defineAsyncComponent(() => import('@/components/DatePicker.vue')),
  'default-eligibility': defineAsyncComponent(() =>
    import('@/components/registration/DefaultEligibility.vue')
  ),
  'display-name-form': defineAsyncComponent(() => import('@/components/DisplayNameForm.vue')),
  'display-seat-time': defineAsyncComponent(() =>
    import('@/components/content/DisplaySeatTime.vue')
  ),
  'download-print': defineAsyncComponent(() => import('@/components/content/DownloadPrint.vue')),
  'dropdown-button': defineAsyncComponent(() => import('@/components/DropdownButton.vue')),
  'edit-question': defineAsyncComponent(() => import('@/components/quiz/EditQuestion.vue')),
  'elearn-subtype': defineAsyncComponent(() => import('@/components/ElearnSubtype.vue')),
  'elevance-eligibility': defineAsyncComponent(() =>
    import('@/components/registration/ElevanceEligibility.vue')
  ),
  'email-template': defineAsyncComponent(() => import('@/components/content/EmailTemplate.vue')),
  'event-card': defineAsyncComponent(() => import('@/components/events/EventCard.vue')),
  'event-details': defineAsyncComponent(() => import('@/components/events/EventDetails.vue')),
  'event-details-banner': defineAsyncComponent(() =>
    import('@/components/events/EventDetailsBanner.vue')
  ),
  'event-details-content-recommendations': defineAsyncComponent(() =>
    import('@/components/events/EventDetailsContentRecommendations.vue')
  ),
  'event-faq': defineAsyncComponent(() => import('@/components/events/EventFaq.vue')),
  'event-recommendation': defineAsyncComponent(() =>
    import('@/components/homepage/EventRecommendation.vue')
  ),
  'event-recommendations-multi-select': defineAsyncComponent(() =>
    import('@/components/admin/events/EventRecommendationsMultiSelect.vue')
  ),
  'event-registration-banner': defineAsyncComponent(() =>
    import('@/components/events/EventRegistrationBanner.vue')
  ),
  'admin-event-register': defineAsyncComponent(() =>
    import('@/components/events/AdminEventRegister.vue')
  ),
  'event-register-cancellation': defineAsyncComponent(() =>
    import('@/components/events/EventRegisterCancellation.vue')
  ),
  'event-url-settings': defineAsyncComponent(() =>
    import('@/components/events/EventUrlSettings.vue')
  ),
  'events-and-registrations': defineAsyncComponent(() =>
    import('@/components/events/EventsAndRegistrations.vue')
  ),
  'expandable-banner': defineAsyncComponent(() =>
    import('@/components/generics/ExpandableBanner.vue')
  ),
  'extended-content-card': defineAsyncComponent(() =>
    import('@/components/content/ExtendedContentCard.vue')
  ),
  'facilitator-bio': defineAsyncComponent(() => import('@/components/events/FacilitatorBio.vue')),
  'faq-list': defineAsyncComponent(() => import('@/components/carepath/FaqList.vue')),
  'favourite-content-list': defineAsyncComponent(() =>
    import('@/components/content/FavouriteContentList.vue')
  ),
  'file-upload': defineAsyncComponent(() => import('@/components/generics/FileUpload.vue')),
  'file-upload-ajax': defineAsyncComponent(() => import('@/components/FileUploadAjax.vue')),
  'floating-button': defineAsyncComponent(() => import('@/components/FloatingButton.vue')),
  'forum-group': defineAsyncComponent(() => import('@/components/forum/ForumGroup.vue')),
  'go-to-next-content': defineAsyncComponent(() =>
    import('@/components/content/GoToNextContent.vue')
  ),
  'header-notifications': defineAsyncComponent(() =>
    import('@/components/navigation/HeaderNotifications.vue')
  ),
  'hero-image': defineAsyncComponent(() => import('@/components/HeroImage.vue')),
  'hero-slider': defineAsyncComponent(() => import('@/components/homepage/HeroSlider.vue')),
  'homepage-update-notification-modal': defineAsyncComponent(() =>
    import('@/components/onboarding/HomepageUpdateNotificationModal.vue')
  ),
  'iframe-page': defineAsyncComponent(() => import('@/components/iframe-page/./IframePage.vue')),
  'image-upload': defineAsyncComponent(() => import('@/components/ImageUpload.vue')),
  'is-private': defineAsyncComponent(() => import('@/components/IsPrivateWidget.vue')),
  'language-selector': defineAsyncComponent(() =>
    import('@/components/translations/LanguageSelector.vue')
  ),
  'lazy-load': defineAsyncComponent(() => import('@/components/LazyLoad.vue')),
  'learning-carousel': defineAsyncComponent(() =>
    import('@/components/learning/LearningCarousel.vue')
  ),
  'learning-header-details': defineAsyncComponent(() =>
    import('@/components/learning/LearningHeaderDetails.vue')
  ),
  'learning-hub-aside': defineAsyncComponent(() =>
    import('@/components/learning-hub/LearningHubAside.vue')
  ),
  'learning-hub-header': defineAsyncComponent(() =>
    import('@/components/learning-hub/LearningHubHeader.vue')
  ),
  'learning-hub-recommend': defineAsyncComponent(() =>
    import('@/components/learning-hub/LearningHubRecommend.vue')
  ),
  'learning-hub-recommendations': defineAsyncComponent(() =>
    import('@/components/learning-hub/LearningHubRecommendations.vue')
  ),
  'learning-page': defineAsyncComponent(() => import('@/pages/LearningPage.vue')),
  'left-nav': defineAsyncComponent(() => import('@/components/navigation/LeftNav.vue')),
  'library-content-slider': defineAsyncComponent(() =>
    import('@/components/content/LibraryContentSlider.vue')
  ),
  'library-dropdown-library-page': defineAsyncComponent(() =>
    import('@/components/search/LibraryDropdownMenu.vue')
  ),
  'library-page': defineAsyncComponent(() => import('@/pages/LibraryPage.vue')),
  'list-questions': defineAsyncComponent(() => import('@/components/quiz/ListQuestions.vue')),
  'list-topics-and-subtopics': defineAsyncComponent(() =>
    import('@/components/topics/ListTopicsAndSubtopics.vue')
  ),
  'list-user-topics': defineAsyncComponent(() => import('@/components/topics/ListUserTopics.vue')),
  'local-event-confirmation-link': defineAsyncComponent(() =>
    import('@/components/admin/events/LocalEventConfirmationLink.vue')
  ),
  location: defineAsyncComponent(() => import('@/components/events/Location.vue')),
  'login-form': defineAsyncComponent(() => import('@/components/login/LoginForm.vue')),
  'lower-app-bar': defineAsyncComponent(() => import('@/components/content/LowerAppBar.vue')),
  'ltss-iowa-eligibility': defineAsyncComponent(() =>
    import('@/components/registration/LtssIowaEligibility.vue')
  ),
  'main-header': defineAsyncComponent(() => import('@/components/navigation/MainHeader.vue')),
  'mark-as-complete': defineAsyncComponent(() => import('@/components/content/MarkAsComplete.vue')),
  'member-data': defineAsyncComponent(() => import('@/components/admin/MemberData.vue')),
  modal: defineAsyncComponent(() => import('@/components/Modal.vue')),
  'module-content-sort-order': defineAsyncComponent(() =>
    import('@/components/certification/ModuleContentSortOrder.vue')
  ),
  'module-quiz': defineAsyncComponent(() =>
    import('@/components/certification/ModuleQuizDropdown.vue')
  ),
  'module-sort-order': defineAsyncComponent(() =>
    import('@/components/certification/ModuleSortOrder.vue')
  ),
  'molina-eligibility': defineAsyncComponent(() =>
    import('@/components/registration/MolinaEligibility.vue')
  ),
  'more-reports': defineAsyncComponent(() => import('@/components/admin/reports/MoreReports.vue')),
  'multi-select-box': defineAsyncComponent(() => import('@/components/MultiSelectBox.vue')),
  'multi-select-box-role': defineAsyncComponent(() =>
    import('@/components/MultiSelectBoxRole.vue')
  ),
  'multi-selection-box-instance': defineAsyncComponent(() =>
    import('@/components/MultiSelectionBoxInstance.vue')
  ),
  'multiple-contents': defineAsyncComponent(() =>
    import('@/components/certification/MultipleContents.vue')
  ),
  'my-profile-page': defineAsyncComponent(() => import('@/components/profile/MyProfilePage.vue')),
  'my-topic': defineAsyncComponent(() => import('@/components/MyTopic.vue')),
  'new-event-date-times': defineAsyncComponent(() =>
    import('@/components/events/NewEventDateTimes.vue')
  ),
  'new-search-layout': defineAsyncComponent(() =>
    import('@/components/search/NewSearchLayout.vue')
  ),
  'onboarding-questionnaire': defineAsyncComponent(() =>
    import('@/components/onboarding/OnboardingQuestionnaire.vue')
  ),
  'phone-number-input': defineAsyncComponent(() =>
    import('@/components/events/PhoneNumberInput.vue')
  ),
  'playlist-aside': defineAsyncComponent(() => import('@/components/playlist/PlaylistAside.vue')),
  'playlist-banner': defineAsyncComponent(() => import('@/components/homepage/PlaylistBanner.vue')),
  'playlist-top-banner': defineAsyncComponent(() =>
    import('@/components/playlist/PlaylistTopBanner.vue')
  ),
  'popular-content-section': defineAsyncComponent(() =>
    import('@/components/content/PopularContentSection.vue')
  ),
  'popular-reports': defineAsyncComponent(() =>
    import('@/components/admin/reports/PopularReports.vue')
  ),
  'post-view': defineAsyncComponent(() => import('@/components/forum/PostView.vue')),
  'profile-bio': defineAsyncComponent(() => import('@/components/profile/ProfileBio.vue')),
  'profile-is-active-modal': defineAsyncComponent(() =>
    import('@/components/profile/ProfileIsActiveModal.vue')
  ),
  'profile-page': defineAsyncComponent(() => import('@/components/profile/ProfilePage.vue')),
  'profile-section-card': defineAsyncComponent(() =>
    import('@/components/profile/ProfileSectionCard.vue')
  ),
  'public-profile-bio': defineAsyncComponent(() =>
    import('@/components/profile/PublicProfileBio.vue')
  ),
  'public-profile-card': defineAsyncComponent(() =>
    import('@/components/profile/PublicProfileCard.vue')
  ),
  'public-profile-field': defineAsyncComponent(() =>
    import('@/components/profile/PublicProfileField.vue')
  ),
  questions: defineAsyncComponent(() => import('@/components/quiz/Questions.vue')),
  'quiz-dropdown': defineAsyncComponent(() => import('@/components/quiz/QuizDropdown.vue')),
  'quiz-player': defineAsyncComponent(() => import('@/components/quiz/QuizPlayer.vue')),
  'recognition-tooltip': defineAsyncComponent(() => import('@/components/RecognitionTooltip.vue')),
  'recommend-by-tag': defineAsyncComponent(() =>
    import('@/components/homepage/RecommendByTag.vue')
  ),
  'recommended-list': defineAsyncComponent(() => import('@/components/RecommendedList.vue')),
  'registration-form': defineAsyncComponent(() =>
    import('@/components/registration-form/RegistrationForm.vue')
  ),
  'registration-invite-form': defineAsyncComponent(() =>
    import('@/components/registration-form/RegistrationInviteForm.vue')
  ),
  'review-question': defineAsyncComponent(() => import('@/components/quiz/ReviewQuestion.vue')),
  'rich-text-editor': defineAsyncComponent(() =>
    import('@/components/generics/RichTextEditor.vue')
  ),
  'save-for-later': defineAsyncComponent(() => import('@/components/content/SaveForLater.vue')),
  scenario: defineAsyncComponent(() => import('@/components/content/ScenarioComponent.vue')),
  'scroll-to-top': defineAsyncComponent(() => import('@/components/content/ScrollToTop.vue')),
  'seagoaaa-registration-invite-part-3': defineAsyncComponent(() =>
    import('@/components/registration-form/instances/SeagoaaaRegistrationInvitePart3.vue')
  ),
  'search-accordion': defineAsyncComponent(() => import('@/components/search/SearchAccordion.vue')),
  'search-input': defineAsyncComponent(() => import('@/components/search/SearchInput.vue')),
  'search-results': defineAsyncComponent(() => import('@/components/search/SearchResults.vue')),
  'select-instance': defineAsyncComponent(() => import('@/components/SelectInstance.vue')),
  'select-location': defineAsyncComponent(() => import('@/components/location/SelectLocation.vue')),
  'select-subject': defineAsyncComponent(() => import('@/components/SelectSubject.vue')),
  'selected-users': defineAsyncComponent(() => import('@/components/SelectUsers.vue')),
  'share-content': defineAsyncComponent(() => import('@/components/content/ShareContent.vue')),
  'short-sign-up': defineAsyncComponent(() => import('@/components/sign-up/ShortSignUp.vue')),
  'single-select-cm': defineAsyncComponent(() => import('@/components/SingleSelectCM.vue')),
  'sit-time': defineAsyncComponent(() => import('@/components/content/SitTime.vue')),
  'slide-out-panel': defineAsyncComponent(() => import('@/components/SlideOutPanel.vue')),
  'sso-profile-questions': defineAsyncComponent(() =>
    import('@/components/sign-up/SsoProfileQuestions.vue')
  ),
  'staff-notes': defineAsyncComponent(() => import('@/components/profile/StaffNotes.vue')),
  'staff-sign-up-form': defineAsyncComponent(() =>
    import('@/components/sign-up/StaffSignUpForm.vue')
  ),
  'steps-progress-bar': defineAsyncComponent(() =>
    import('@/components/content/StepsProgressBar.vue')
  ),
  'story-card': defineAsyncComponent(() => import('@/components/StoryCard.vue')),
  'support-page': defineAsyncComponent(() => import('@/pages/SupportPage.vue')),
  'survey-gizmo-modal': defineAsyncComponent(() => import('@/components/SurveyGizmoModal.vue')),
  'tab-nav': defineAsyncComponent(() => import('@/components/navigation/TabNav.vue')),
  'tag-select': defineAsyncComponent(() => import('@/components/homepage/TagSelect.vue')),
  'testimonial-slider': defineAsyncComponent(() =>
    import('@/components/testimonial/TestimonialSlider.vue')
  ),
  'text-banner': defineAsyncComponent(() => import('@/components/banners/TextBanner.vue')),
  'today-user-events': defineAsyncComponent(() =>
    import('@/components/homepage/TodayUserEvents.vue')
  ),
  'toolkit-overview-page': defineAsyncComponent(() => import('@/pages/ToolkitOverviewPage.vue')),
  'toolkit-card': defineAsyncComponent(() => import('@/components/toolkit/ToolkitCard.vue')),
  'toolkit-outline': defineAsyncComponent(() => import('@/components/toolkit/ToolkitOutline.vue')),
  'toolkit-recommend': defineAsyncComponent(() =>
    import('@/components/admin/ToolkitRecommend.vue')
  ),
  'toolkit-tab-translations': defineAsyncComponent(() =>
    import('@/components/toolkit/ToolkitTabTranslations.vue')
  ),
  'toolkit-tabs': defineAsyncComponent(() => import('@/components/toolkit/ToolkitTabs.vue')),
  'toolkit-tabs-translations': defineAsyncComponent(() =>
    import('@/components/toolkit/ToolkitTabsTranslations.vue')
  ),
  'topic-order': defineAsyncComponent(() => import('@/components/TopicOrder.vue')),
  'transition-expand': defineAsyncComponent(() =>
    import('@/components/transition/TransitionExpand.vue')
  ),
  'translation-edit-question': defineAsyncComponent(() =>
    import('@/components/quiz/TranslationEditQuestion.vue')
  ),
  'translation-list-questions': defineAsyncComponent(() =>
    import('@/components/quiz/TranslationListQuestions.vue')
  ),
  'tutorial-modal': defineAsyncComponent(() => import('@/components/TutorialModal.vue')),
  'user-activity-card': defineAsyncComponent(() =>
    import('@/components/profile/UserActivityCard.vue')
  ),
  'user-contact-list-date-range': defineAsyncComponent(() =>
    import('@/components/staff/UserContactListDateRange.vue')
  ),
  'user-contact-list-table': defineAsyncComponent(() =>
    import('@/components/staff/UserContactList.vue')
  ),
  'user-profile-page': defineAsyncComponent(() => import('@/pages/UserProfilePage.vue')),
  'user-select-cm': defineAsyncComponent(() => import('@/components/staff/UserSelectCM.vue')),
  'video-conference-frame': defineAsyncComponent(() =>
    import('@/components/events/VideoConferenceFrame.vue')
  ),
  'vimeo-player': defineAsyncComponent(() => import('@/components/content/VimeoPlayer.vue')),
  'wayne-eligibility': defineAsyncComponent(() =>
    import('@/components/registration/WayneEligibility.vue')
  ),
  'webinar-details': defineAsyncComponent(() => import('@/components/events/WebinarDetails.vue')),
  'week-list-plan': defineAsyncComponent(() => import('@/components/carepath/WeekListPlan.vue')),
  'support-recommendations': defineAsyncComponent(() =>
    import('@/components/homepage/SupportRecommendations.vue')
  ),
  'landing-page-features': defineAsyncComponent(() =>
    import('@/components/landing-page/LandingPageFeatures.vue')
  ),
};

export function registerGlobalComponents(app) {
  Object.entries(globalComponents).forEach(([name, component]) => {
    app.component(name, component);
  });
}

export default globalComponents;
